import React from 'react';
import "./dashboardApiGateway.css"
import PieChart from "./PieCharts.tsx";
import gatewayIcon from "../../../assets/gatewayImg.svg";

const DashboardApiGateway = () => {
    return (
        <div className='dashboardApiGatewayMainContainer'>
            <div style={{marginLeft:"-5px"}} className='dashboardApiGatewayTopContainer'>
            <span><img className='gatewayImg' src={gatewayIcon} alt="gatewayIcon" /></span>
                <p className='EnvDataHeading'>API Gateway</p>
            </div>
            <div className='dashboardApiGatewayBottomContainer'>
                <div className="dashboardApiGatewayInfoTopContainer">
                    <p className='Temperature' style={{ marginBottom: "0px" }}>Load Percentage</p>
                </div>
                <div className="dashboardApiGatewayInfoBottomContainer">
                    <div className='usedText'>
                        <span>Used</span>
                        <span className='usedMemoryInfo' style={{display:"flex",justifyContent:"center"}}>70%</span>
                    </div>
                    <PieChart />
                    <div className='freeText'>
                        <span>Free</span>
                        <span className='freeMemoryInfo' style={{display:"flex",justifyContent:"center"}}>30%</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardApiGateway;